export const environment = {
  production: false,
  apiUrl: 'https://ermsurvey-api-dev.adient.com/',  
  clientId: 'c1acdf83-18a4-4495-92d8-5abe01b0cc18',
  redirectUri: 'https://ermsurvey-dev.adient.com',
  postLogoutRedirectUri: 'https://connect.adient.com/'

};
